import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import { authAPI, getConfig } from "../../../apis";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import EmailInput from "../../../pages/SavedPage/EmailBlock/EmailUserBlock";
import InputText from "../../../components/input/InputText";
import { useDispatch } from "react-redux";
import { setChangeEmailPopup } from "../../../redux/features/dataSlice";
import { axiosInstance } from "../../../functions/axios";

const PopupChangeEmail = (props) => {
  const { email, setEmail } = props;
  const [otpPopup, setOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [tempEmail, setTempEmail] = useState("");
  const [confirmEmail, setCOnfirmEmail] = useState("");
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const setShowPopup = (val) => {
    dispatch(setChangeEmailPopup(val));
  };

  const customValidation = () => {
    if (tempEmail !== confirmEmail) {
      return false;
    }
    return true;
  };

  const changeEmail = async () => {
    if (tempEmail === "") {
      toast.error("Please enter a new email address.");
      return;
    }

    if (confirmEmail === "") {
      toast.error("Please re-enter the new email address.");
      return;
    }

    if (tempEmail !== confirmEmail) {
      toast.error("Email and Confirm Email do not match.");
      return;
    }

    try {
      const { data } = await axiosInstance.post(
        `${authAPI.changeEmail}`,
        {
          userId: user.userId,
          newEmail: tempEmail,
        },
        getConfig()
      );
      setOtpPopup(true);
      toast.success(
        "Success! Please enter the code we sent you to confirm your new email. "
      );
      console.log(data);
    } catch (e) {
      if (e.response.data.code === 409) {
        toast.error("Sorry, this email is already being used!");
      } else {
        toast.error("Please enter a valid email address.");
      }
    }
  };

  const closePopup = () => {
    setEmail(tempEmail);
    setTempEmail("");
    setCOnfirmEmail("");
    setShowPopup(false);
    setOtpPopup(false);
  };

  const verifyEmail = async () => {
    try {
      const { data } = await axiosInstance.post(
        `${authAPI.verifyChangeEmail}`,
        {
          userId: user.userId,
          newEmail: tempEmail,
          provider: "Email",
          code: otp,
        },
        getConfig()
      );
      toast.success("Email changed successfully.");
      localStorage.setItem("email", tempEmail);
      closePopup();
    } catch {
      toast.error("Code mismatch. Please enter a valid code.");
    }
  };

  const divRef = useRef(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (!otpPopup) {
        changeEmail();
      } else {
        verifyEmail();
      }
    }
  };

  return (
    <>
      <div
        ref={divRef}
        onKeyDown={(e) => handleKeyDown(e)}
        className="change-email-popup"
      >
        {" "}
        <div className="popup-card">
          <p className="title">Change Email</p>
          <div className="divider-email" />
          <>
            <p className="popup-title">Change current email address {email}</p>
            <p className="popup-title">
              To change the email associated with your Sooth account, please
              enter the new email below. We will send a confirmation code to the
              new email. You'll then be asked to provide that code in order to
              confirm the email change.{" "}
            </p>

            <InputText
              value={tempEmail}
              validation="email"
              onChange={(e) => setTempEmail(e.target.value)}
              placeholder="Enter new email address"
            />
            <div className="mt-2"></div>
            <InputText
              value={confirmEmail}
              validation="custom"
              customValidation={customValidation}
              onChange={(e) => setCOnfirmEmail(e.target.value)}
              placeholder="Please re-enter the new email address"
            />
            <div className="divider-email mt-5" />
            <div className="save-actions">
              <div className="flex">
                <ButtonPrimary text="Send Code" onClick={changeEmail} />
              </div>
            </div>
          </>
          {otpPopup && (
            <>
              <div className="bg-dark" />
              <div className="popup-card-top">
                <div
                  className="cross"
                  onClick={() => {
                    setOtpPopup(false);
                  }}
                >
                  <CloseIcon />{" "}
                </div>
                <p className="popup-title">
                  Please enter the confirmation code we emailed you
                </p>
                <InputText
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter code here"
                />
                <div className="divider-email mt-5" />
                <div className="save-actions">
                  <div className="flex">
                    <ButtonPrimary text="Confirm" onClick={verifyEmail} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PopupChangeEmail;
